import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuVisible: false,
    selectedmaptheme: {},
    facts: [],
    themeIdentifyValue: null,
  },
  mutations: {
    toogleMenu(state) {
      state.menuVisible = !state.menuVisible;
    },
    setselectedmaptheme(state, maptheme) {
      state.selectedmaptheme = maptheme;
    },
    setFacts(state, facts) {
      state.facts = facts;
    },
    setThemeIdentifyValue(state, value) {
      state.themeIdentifyValue = value;
    },
  },
  actions: {},
});
